import ScreensaverScheduleContainer from 'components/feature/screensaver/schedule/list/ScreensaverScheduleContainer';
import React from 'react';

const ScreensaverSchedulePage = () => {
  return <ScreensaverScheduleContainer />;
};
export default ScreensaverSchedulePage;
